import { combineReducers } from '@reduxjs/toolkit';
import dashboard from 'layouts/dashboards/store/dashboardSlice';
import userDetails from './userDetailsSlice';
import logout from 'examples/Navbars/store/logoutSlice';
import calendarEvent from 'layouts/dashboards/dashboard/components/dashboardCalendar/store/calendarEventSlice';
import tutoringSubjects from 'layouts/tutoring/store/tutoringSubjectsSlice/tutoringSubjectsSlice';
import tutoringAvailability from 'layouts/tutoring/store/tutoringAvailabilitySlice/tutoringAvailabilitySlice';

export const rootReducer = combineReducers({
  dashboard,
  userDetails,
  calendarEvent,
  logout,
  tutoringSubjects,
  tutoringAvailability
});
